<script lang="ts">
  import EditGrid from '../../Cards/EditGrid.svelte'
  import AuthedUserTopBarPage from '../../Navigation/TopLevelPages/AuthedUserTopBarPage.svelte'
  import { Modal as UnTypedModal } from 'svelte-simple-modal'
  import { SvelteComponentTyped } from 'svelte'
  // TODO fix this ugly casting in all places its used
  const Modal = UnTypedModal as unknown as new (...args: any) => SvelteComponentTyped
</script>

<AuthedUserTopBarPage>
  <Modal>
    <EditGrid />
  </Modal>
</AuthedUserTopBarPage>
